import { render, staticRenderFns } from "./AdminBrandsMarketplace.vue?vue&type=template&id=122670b4&scoped=true&"
import script from "./AdminBrandsMarketplace.vue?vue&type=script&lang=js&"
export * from "./AdminBrandsMarketplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122670b4",
  null
  
)

export default component.exports